import React, {useCallback, useEffect, useState} from 'react';
import {Table} from 'antd'
import DraggableModal from "../../components/DraggableModal";
import Api from '../../api'
import {toVideoTime, toTime} from "../../util/time";

export default function HistoryModal({onClose, isShow,id}) {
    const [list, setList] = useState()
    const [isOpen, setIsOpen] = useState(false)
    const [total, setTotal] = useState(0)
    const [pageIndex, setPageIndex] = useState(1)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setIsOpen(isShow)
    }, [isShow])

    useEffect(()=>{
        if (id) {
            loadData(true)
        }
    },[id])

    useEffect(()=>{
        if (id) {
            loadData();
        }
    },[pageIndex])

    const loadData = useCallback((reset)=>{
        if (loading) return;
        setLoading(true)
        Api.getStudentLearnList({
            studentId:id,
            pageIndex: reset?1:pageIndex
        }).then(resp=>{
            setLoading(false)
            setList(resp.list||[])
            setPageIndex(resp.pageIndex)
            setTotal(resp.totalCount)
        })
    })

    const columns = [
        {
            title: '课程名称',
            key: 'id',
            render: (_, record) => {
                return <span>{record.courseName}({record.courseId})</span>
            }
        },
        {
            title: '课程内容',
            key: 'name',
            width: 240,
            render: (_, record) => {
                return  <span className="mgl10">{record.courseInfoName}</span>
            }
        },
        {
            title: '课程时长',
            key: 'name',
            align: 'center',
            width: 88,
            render: (_, record) => {
                return record.typeCode === 1?
                    <span>{toVideoTime(record.totalNumber)}</span>:
                    <span>{record.totalNumber}图</span>
            }
        },{
            title: '观看进度',
            key: 'name',
            width: 88,
            align: 'center',
            render: (_, record) => {
                return <span>{Math.round(record.useNumber*100/record.totalNumber)}%</span>
            }
        },
        {
            title: '观看时间',
            key: 'action',
            width:176,
            render: (_, record) => {
                return <span>{toTime(record.updateTime)}</span>
            }
        },
    ];

    return <DraggableModal
        title="观看记录"
        open={isOpen}
        onOk={onClose}
        onCancel={onClose}
        okText="确认"
        cancelText="取消"
        footer={null}
        width={980}
    >
        <Table
            columns={columns}
            dataSource={list}
            rowKey="id"
            pagination={{
                total: total,
                pageSize: 8,
                current: pageIndex,
                showSizeChanger: false,
                onChange: (index)=>setPageIndex(index)

            }}
        />
    </DraggableModal>
}